import App from "./App";
import PathProvider from "./libs/path/PathProvider";
import "./scss/index.scss"

import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import FManApi from "./fmanlibs/FManApi";
import SnackbarProvider from "./gui/Snackbar/SnackbarProvider";
import OverlayProvider from "./gui/Overlay/OverlayProvider";
import AuthProvider from "./gui/Login/AuthProvider";
import LoginProvider from "./gui/Login/LoginProvider";
import RootProvider from "./fmanlibs/RootProvider";
import SelectionProvider from "./fmanlibs/SelectionProvider";
import FilesProvider from "./fmanlibs/FilesProvider";
import UploadProvider from "./fmanlibs/UploadProvider";

(async () => {
    const root = ReactDOM.createRoot(document.getElementById("root")!)

    FManApi.i.init()
    
    root.render(
    <AuthProvider api={FManApi.i}>
        <PathProvider><SnackbarProvider><OverlayProvider><LoginProvider api={FManApi.i}>
            <RootProvider>
                <SelectionProvider><FilesProvider>
                    <UploadProvider>
                        <App/>  
                    </UploadProvider>
                </FilesProvider></SelectionProvider>
            </RootProvider>
    </LoginProvider></OverlayProvider></SnackbarProvider></PathProvider>
    </AuthProvider>)

    serviceWorkerRegistration.register()
})()